import { cycleCountRuleIdFormat } from "@redotech/redo-model/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const cycleCountRuleListItem = z.object({
  id: cycleCountRuleIdFormat.schema,
  name: z.string(),
  description: z.string().nullable(),
  type: z.literal("abc"),
  status: z.enum(["live", "disabled", "draft"]),
  data: z.unknown(),
  dueDaysAfterCreation: z.int(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const cycleCountRuleSortBySchema = z.enum(["name", "status", "type"]);

export const listCycleCountRules = unaryRpc({
  name: "listCycleCountRules" as const,
  input: z.object({
    search: z.string().nullable(),
    sortBy: cycleCountRuleSortBySchema.nullable(),
    sortDirection: z.enum(["asc", "desc"]).nullable(),
  }),
  output: z.object({ rules: z.array(cycleCountRuleListItem) }),
});
